import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import firebase, { db, storage, auth } from '../../settings/firebase';
import './Post.css'

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));


class Post extends React.Component {
  constructor(props){
    super(props);
    const locparams = window.location.search.replace("?", "").split("&")
    let params = {}
    locparams.forEach(element => {
      const param = element.split("=")
      params[param[0]] = param[1]
    });
    let docId = "";
    let isedit = false;
    if (params["pid"]) {
      docId = params["pid"];
      isedit = true;
    } else {
      docId = db.collection("articles").doc().id
    }
    this.state = {
      changeUrlTimer: "",
      url: "",
      fetchUrl: false,
      page: {result: false},
      uid: "",
      ganre: "",
      title: "",
      comment: "",
      image: [],
      docId: docId,
      isedited: isedit,  //編集モードか、新規作成か
      isPosting: false,  //投稿処理状態
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
    this.changeGanre = this.changeGanre.bind(this);
    this.changeTitle = this.changeTitle.bind(this);
    this.changeComment = this.changeComment.bind(this);
    this.fetchUrl = this.fetchUrl.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
  }

  _isMounted = false;

  async componentDidMount() {
    let uid = "";
    await auth.onAuthStateChanged(user => {
      if (user) {
        uid = user.uid;
        this.setState({uid: uid});
      }
    })
    if (this.state.isedited) {
      await db.collection("items").doc(this.state.docId).get().then(doc => {
        if (doc.exists) {
          if (uid === doc.data().recommender) {
            this.setState({
              url: doc.data().url,
              fetchUrl: true,
              page: {result: true, data: {
                ogTitle: doc.data().urlTitle, ogDescription: doc.data().description,
                ogImage: doc.data().thumbnail, ogSiteName: doc.data().siteName,
                ogType: doc.data().siteType, url: doc.data().url, 
              }},
              image: doc.data().image,
              ganre: doc.data().ganre,
              title: doc.data().title,
              comment: doc.data().comment,
            });
          } else {
            this.setState({isedited: false});
          }
        } else {
          this.setState({isedited: false});
        }
      }).catch((error) => {
        alert("Error writing document: ", error);
      });
    }
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  changeUrl(e) {
    if(this.state.changeUrlTimer !== "") {
      clearTimeout(this.state.changeUrlTimer);
    }
    let timerId = "";
    if(e.target.value.match(/.+\..+/)) {
      timerId = setTimeout( this.fetchUrl , 3000 );
    }
    this.setState({changeUrlTimer: timerId, url: e.target.value, fetchUrl: false});
    // console.log(e.target.value);
  }

  // URLからOGPを取得する
  async fetchUrl() {
    console.log(this.state.url)
    const url = "https://" + process.env.REACT_APP_GET_URL_OGP_DOMAIN + "/get?url=" + this.state.url;
    const requestOptions ={
      method: 'GET',
      headers:{'Content-Type': 'application/json'},
    };
    await fetch(url,requestOptions).then((response)=> response.json()
    ).then((responseJson) =>{
      this.setState({page: responseJson});
      console.log(responseJson);
    })
    this.setState({changeUrlTimer: "", fetchUrl: true});
  }

  changeGanre(e) {
    this.setState({ganre: e.target.value});
  }

  changeTitle(e) {
    this.setState({title: e.target.value});
  }

  changeComment(e) {
    this.setState({comment: e.target.value});
    // console.log(e.target.value);
  }

  async handleOnSubmit() {
    // もし必須項目が抜けていたら、拒否する
    if(this.state.fetchUrl === "" || this.state.ganre === "" || this.state.title === "" || this.state.comment === "") {
      console.log(this.state.fetchUrl, this.state.ganre, this.state.title, this.state.comment)
      alert("URL、ジャンル、タイトル、コメントは必須です。");
      console.log("Error: 必須項目が入力されていません");
      return;
    }
    this.setState({isPosting: true});
    if(!this.state.fetchUrl){
      // Fetchする
      await this.fetchUrl();
    }
    // Fetch先が有効なページだったか確認
    if(this.state.comment.length > 0 && this.state.page.result) {
      // Firestoreに登録
      const docId = this.state.docId;
      console.log(this.state.page.data)
      let isPostStatus = false;
      if (this.state.isedited) {  // 編集投稿
        await db.collection("items").doc(docId).update({
          urlTitle: this.state.page.data.ogTitle,
          description: this.state.page.data.ogDescription,
          title: this.state.title,
          comment: this.state.comment,
          url: this.state.page.data.url,
          thumbnail: this.state.page.data.ogImage,
          image: [],
          siteName: this.state.page.data.ogSiteName,
          siteType: this.state.page.data.ogType,
          ganre: this.state.ganre,
          tag: [],
          recommender: this.state.uid,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then(async () => {
          isPostStatus = true;
        })
        .catch((error) => {
          alert("Error writing document: ", error);
        });
      } else { // 新規投稿
        await db.collection("items").doc(docId).set({
          urlTitle: this.state.page.data.ogTitle,
          description: this.state.page.data.ogDescription,
          title: this.state.title,
          comment: this.state.comment,
          url: this.state.page.data.url,
          thumbnail: this.state.page.data.ogImage,
          image: [],
          siteName: this.state.page.data.ogSiteName,
          siteType: this.state.page.data.ogType,
          ganre: this.state.ganre,
          tag: [],
          recommender: this.state.uid,
          click: [],
          like: [],  // いいね
          star: 0,  // お気に入り
          quote: [],  // 引用
          type: "url",  // 記事タイプ
          messages: [],  // コメントメッセージ
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }).then(async () => {
          isPostStatus = true;
        })
        .catch((error) => {
          alert("Error writing document: ", error);
        });
      }
      this.setState({isPosting: false})
      if (isPostStatus) {
        let userdid = "post";
        await db.collection("users").doc(this.state.uid).get().then(doc => {
          if (doc.exists) {
            userdid = doc.data().displayid;
            //登録後、投稿したページに移動
            this.props.history.push("/" + userdid + "/p/" + docId + "?status=success");
          }
        })
      }
    }
    else {
      alert("このURLは現在使用できません。");
      console.log("Error: URLが正しくありません");
      this.setState({isPosting: false})
    }
  }

  render() {
    return (
      <div className={"postdiv"}>
        {this.state.isedited? <h1>編集</h1>: <h1>あなたのおすすめを<br/>投稿しよう！</h1>}
        <form className={useStyles.root + " postForm"} onSubmit={this.handleOnSubmit} noValidate autoComplete="off">
          <div className={"inputarea"}>
            <TextField id="input-url" className={"inputbox"} placeholder="https://"
              variant="outlined" onChange={this.changeUrl} value={this.state.url} />
          </div>
          <div className={"inputarea"}>
            <InputLabel id="input-ganre-label" className={"inputlabel"} style={{fontSize: "24px"}}>ジャンル</InputLabel>
            <Select
              labelId="input-ganre-label"
              id="input-ganre"
              value={this.state.ganre}
              variant="outlined"
              placeholder="ジャンルを選択してください"
              style={{width: "100%"}}
              onChange={this.changeGanre}
            >
              <MenuItem value={"youtube"}>YouTube</MenuItem>
              <MenuItem value={"recently"}>最近買ってよかったもの</MenuItem>
              <MenuItem value={"free"}>なんでも</MenuItem>
            </Select>
          </div>
          <div className={"inputarea"}>
            <InputLabel id="input-title-label" className={"inputlabel"} style={{fontSize: "24px"}}>題名</InputLabel>
            <TextField id="input-title" className={"inputbox"} labelId="input-title-label"
              placeholder="あなたの想いを題名にしましょう！" variant="outlined" onChange={this.changeTitle} value={this.state.title}
            />
          </div>
          <div className={"inputarea"}>
            <InputLabel id="input-comment-label" className={"inputlabel"} style={{fontSize: "24px"}}>コメント</InputLabel>
            <TextField id="input-comment" className={"inputbox"} labelId="input-comment-label"
              placeholder="商品や体験との出会い、おすすめしたいポイントなど、気軽に投稿しましょう！"
              variant="outlined" multiline={true} rows="6" onChange={this.changeComment} value={this.state.comment}
            />
          </div>
          <div style={{height: "20px"}} />
          <Button
            type="button"
            onClick={this.handleOnSubmit}
            fullWidth
            variant="contained"
            color="primary"
            className={"postSubmitBtn"}
          >
            {this.state.isedited? <>更新</> : <>投稿</>}
          </Button>
        </form>
      </div>
    )
  }
}

export default Post